import {Component, Input} from '@angular/core';
import {CreateUpdateComponent} from '../create-update.component'
import {translations} from '../../../../../environments/translations.ru'

@Component({
  selector: 'app-create-update-header',
  standalone: false,
  templateUrl: './create-update-header.component.html',
  styles: `
    :host {
      display: block;
      margin-bottom: 15px;
    }
    .text-bg-secondary {
      padding: 5px 10px 4px;
      border-radius: 7px;
    }
  `,
})
export class CreateUpdateHeaderComponent {
  @Input() model: CreateUpdateComponent<any>;
  protected readonly translations = translations
}
